/* ========================================================================
   HERMES SMILEKIT v1 — Clean Beauty-Lab · Ciencia del Color
   Anim set: preloader counter 00→100 · BlurText · letter reveal · count-up ·
             before/after drag slider · foam-rise stagger · variant sync ·
             anti-spy · desktop-block · Releasit integration · sticky CTA
   ======================================================================== */
(function () {
  'use strict';

  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var section = $('.hm-smk');
  if (!section) return;

  var isTouch = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
  if (isTouch) document.body.classList.add('is-touch');

  /* ── 0) DESKTOP BLOCK + ANTI-SPY ─────────────────────────────── */
  var caught = $('.hm-smk-caught');

  function isDesktop() {
    return (
      window.matchMedia('(min-width: 1024px)').matches ||
      (window.matchMedia('(hover: hover) and (pointer: fine)').matches && !isTouch)
    );
  }
  function showCaught(mode) {
    if (!caught) return;
    caught.classList.remove('is-mode-spy', 'is-mode-desktop');
    caught.classList.add('is-active', 'is-mode-' + mode);
  }

  if (section.classList.contains('hm-smk--desktop-block') && isDesktop()) {
    showCaught('desktop');
    return; // short-circuit — no further init on blocked desktop
  }

  if (section.classList.contains('hm-smk--anti-spy')) {
    document.addEventListener('contextmenu', function (e) { e.preventDefault(); showCaught('spy'); });
    document.addEventListener('keydown', function (e) {
      var key = (e.key || '').toLowerCase();
      if (key === 'f12') { e.preventDefault(); showCaught('spy'); return; }
      if ((e.ctrlKey || e.metaKey) && e.shiftKey && (key === 'i' || key === 'j' || key === 'c')) { e.preventDefault(); showCaught('spy'); return; }
      if ((e.ctrlKey || e.metaKey) && (key === 'u' || key === 's' || key === 'p')) { e.preventDefault(); showCaught('spy'); return; }
    });
    setInterval(function () {
      var delta = Math.abs(window.outerWidth - window.innerWidth) + Math.abs(window.outerHeight - window.innerHeight);
      if (delta > 200) showCaught('spy');
    }, 1500);
    $$('.hm-smk img, .hm-smk video').forEach(function (el) {
      el.setAttribute('draggable', 'false');
      el.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });
  }

  /* ── 1) PRELOADER counter 00 → 100 + rotating words ──────────── */
  (function preloader() {
    var pre = $('#hm-smk-preloader'), ctr = $('#hm-smk-counter'), bar = $('#hm-smk-bar'), wrap = $('#hm-smk-words');
    if (!pre || !ctr || !bar) return;
    var target = 100, duration = 2200, start = performance.now();
    function tick(t) {
      var p = Math.min(1, (t - start) / duration);
      var ease = 1 - Math.pow(1 - p, 3);
      ctr.textContent = String(Math.floor(ease * target)).padStart(2, '0');
      bar.style.width = (ease * 100) + '%';
      if (p < 1) requestAnimationFrame(tick);
      else setTimeout(function () { pre.classList.add('is-done'); }, 340);
    }
    requestAnimationFrame(tick);
    if (wrap) {
      var pwords = $$('.hm-smk-pw', wrap), idx = 0;
      setInterval(function () {
        pwords[idx].classList.remove('active');
        idx = (idx + 1) % pwords.length;
        pwords[idx].classList.add('active');
      }, 480);
    }
  })();

  /* ── 2) BLUR-TEXT word-by-word (hero headline) ───────────────── */
  (function blurText() {
    $$('.hm-smk-blur-text').forEach(function (el) {
      var src = el.getAttribute('data-blur-text') || '';
      el.textContent = '';
      src.split(/\s+/).filter(Boolean).forEach(function (w, i) {
        var span = document.createElement('span');
        span.className = 'hm-smk-blur-text__word';
        span.style.setProperty('--d', (0.15 + i * 0.10) + 's');
        span.textContent = w;
        el.appendChild(span);
      });
    });
    setTimeout(function () { $$('.hm-smk-blur-text__word').forEach(function (w) { w.classList.add('is-in'); }); }, 820);
  })();

  /* ── 3) LETTER-BY-LETTER reveal (pull-quote) ─────────────────── */
  (function letterReveal() {
    $$('[data-letter-reveal]').forEach(function (el) {
      var src = el.getAttribute('data-source') || '';
      el.innerHTML = '';
      var rx = /(<em>[^<]*<\/em>)|(\S)|(\s+)/g, m, i = 0;
      while ((m = rx.exec(src)) !== null) {
        if (m[1]) {
          var emTxt = m[1].replace(/<\/?em>/g, ''), em = document.createElement('em');
          for (var k = 0; k < emTxt.length; k++) {
            var ch = emTxt[k];
            if (ch === ' ') { em.appendChild(document.createTextNode(' ')); continue; }
            var s = document.createElement('span');
            s.className = 'hm-smk-letter'; s.style.setProperty('--d', (i * 0.018) + 's'); s.textContent = ch;
            em.appendChild(s); i++;
          }
          el.appendChild(em);
        } else if (m[2]) {
          var sp = document.createElement('span');
          sp.className = 'hm-smk-letter'; sp.style.setProperty('--d', (i * 0.018) + 's'); sp.textContent = m[2];
          el.appendChild(sp); i++;
        } else if (m[3]) { el.appendChild(document.createTextNode(m[3])); }
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { $$('.hm-smk-letter', el).forEach(function (l) { l.classList.add('is-in'); }); io.disconnect(); }
        });
      }, { threshold: 0.4 });
      io.observe(el);
    });
  })();

  /* ── 4) COUNT-UP stats ───────────────────────────────────────── */
  (function countUp() {
    $$('.hm-smk-stat__num').forEach(function (el) {
      var target = parseFloat(el.getAttribute('data-target') || '0');
      var suffix = el.getAttribute('data-suffix') || '';
      var prefix = el.getAttribute('data-prefix') || '';
      if (isNaN(target)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var dur = 1500, start = performance.now();
          function tick(t) {
            var p = Math.min(1, (t - start) / dur), ease = 1 - Math.pow(1 - p, 3);
            el.textContent = prefix + Math.floor(ease * target) + suffix;
            if (p < 1) requestAnimationFrame(tick); else el.textContent = prefix + target + suffix;
          }
          requestAnimationFrame(tick);
          entry.target.classList.add('is-in');
          io.disconnect();
        });
      }, { threshold: 0.5 });
      io.observe(el);
    });
  })();

  /* ── 5) BEFORE / AFTER drag slider ───────────────────────────── */
  (function beforeAfter() {
    var stage = $('#hm-smk-ba');
    if (!stage) return;
    var dragging = false;
    function setPos(clientX) {
      var rect = stage.getBoundingClientRect();
      var pct = ((clientX - rect.left) / rect.width) * 100;
      pct = Math.max(2, Math.min(98, pct));
      stage.style.setProperty('--ba', pct + '%');
    }
    stage.addEventListener('mousedown', function (e) { dragging = true; setPos(e.clientX); });
    window.addEventListener('mousemove', function (e) { if (dragging) setPos(e.clientX); });
    window.addEventListener('mouseup', function () { dragging = false; });
    stage.addEventListener('touchstart', function (e) { var t = e.touches[0]; if (t) setPos(t.clientX); }, { passive: true });
    stage.addEventListener('touchmove', function (e) { var t = e.touches[0]; if (t) setPos(t.clientX); }, { passive: true });
    // Auto demo nudge on first view
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.disconnect();
        var seq = [50, 70, 30, 50], i = 0;
        var iv = setInterval(function () {
          stage.style.setProperty('--ba', seq[i] + '%');
          i++; if (i >= seq.length) clearInterval(iv);
        }, 480);
      });
    }, { threshold: 0.5 });
    io.observe(stage);
  })();

  /* ── 6) FADE-RISE / foam-rise stagger ────────────────────────── */
  (function fadeRise() {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
      });
    }, { threshold: 0.16 });
    $$('.hm-smk-stat, .hm-smk-step, .hm-smk-bento__cell').forEach(function (el, i) {
      el.style.setProperty('--sd', (i % 4 * 0.08) + 's');
      io.observe(el);
    });
  })();

  /* ── 7) VARIANT SELECTOR sync (no-op if SIMPLE) ──────────────── */
  (function variantSync() {
    var wrap = $('[data-hm-smk-variants]');
    if (!wrap) return;
    var jsonEl = $('[data-hm-smk-variants-json]', wrap), variants = [];
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) {}
    var groups = $$('.hm-smk-hero__variant-options', wrap);
    var selected = new Array(groups.length);
    groups.forEach(function (grp, i) {
      var act = $('.hm-smk-variant-opt--active', grp);
      selected[i] = act ? act.getAttribute('data-option-value') : null;
    });
    function formatCOP(cents) { return '$' + (cents / 100).toLocaleString('es-CO', { maximumFractionDigits: 0 }); }
    function findVariant() {
      return variants.find(function (v) {
        var o = [v.option1, v.option2, v.option3];
        for (var i = 0; i < groups.length; i++) { if (selected[i] && o[i] !== selected[i]) return false; }
        return true;
      });
    }
    function apply(v) {
      if (!v) return;
      var inp = $('[data-hm-smk-variant-input]'); if (inp) inp.value = v.id;
      if (typeof v.price === 'number') {
        var p = formatCOP(v.price);
        [$('.hm-smk-hero__price-now'), $('.hm-smk-final__now'), $('.hm-smk-sticky-cta__now')].forEach(function (e) { if (e) e.textContent = p; });
      }
      window._RSI_COD_FORM_OVERWRITE_ATC_ITEMS = [{ id: v.id, quantity: 1 }];
    }
    groups.forEach(function (grp, gi) {
      $$('.hm-smk-variant-opt', grp).forEach(function (btn) {
        btn.addEventListener('click', function () {
          $$('.hm-smk-variant-opt', grp).forEach(function (b) { b.classList.remove('hm-smk-variant-opt--active'); });
          btn.classList.add('hm-smk-variant-opt--active');
          selected[gi] = btn.getAttribute('data-option-value');
          apply(findVariant());
        });
      });
    });
  })();

  /* ── 8) RELEASIT INTEGRATION ─────────────────────────────────── */
  (function releasit() {
    var heroCta = $('[data-hm-smk-cta-proxy]');
    var mainCta = $('[data-hm-smk-main-cta]');
    if (heroCta) {
      heroCta.addEventListener('click', function (e) {
        var rsiBtn = document.querySelector('._rsi-buy-now-button:not(._rsi-buy-now-button-floating), #_rsi-buy-now-button-overwrite');
        if (rsiBtn) { e.preventDefault(); rsiBtn.click(); return; }
        if (mainCta) { e.preventDefault(); mainCta.click(); }
      });
    }
    var attempts = 0;
    var poll = setInterval(function () {
      attempts++;
      var rsiBtn = document.querySelector('._rsi-buy-now-button, #_rsi-buy-now-button-overwrite');
      if (rsiBtn) { clearInterval(poll); console.info('[HERMES smilekit-v1] Releasit button detected.'); }
      else if (attempts > 40) { clearInterval(poll); console.warn('[HERMES smilekit-v1] Releasit not detected — check Dropi metafield + dashboard.'); }
    }, 500);
  })();

  /* ── 9) Scroll-hint hide ─────────────────────────────────────── */
  (function scrollHint() {
    var hint = $('.hm-smk-hero__scrollhint'); if (!hint) return;
    var hide = function () { if (window.scrollY > 80) { hint.style.opacity = '0'; window.removeEventListener('scroll', hide); } };
    window.addEventListener('scroll', hide, { passive: true });
  })();

  /* ── 10) STICKY CTA bottom (mobile) ──────────────────────────── */
  (function stickyCta() {
    var sticky = $('.hm-smk-sticky-cta'), heroCta = $('.hm-smk-hero__cta'), finalSec = $('#hm-smk-cta-final');
    if (!sticky || !heroCta) return;
    function killFloating() {
      $$('[class*="_rsi-buy-now"][class*="floating"], ._rsi-buy-now-button-floating, [class*="_rsi-floating"]').forEach(function (el) {
        el.style.display = 'none'; el.style.visibility = 'hidden'; el.style.opacity = '0'; el.style.pointerEvents = 'none';
      });
    }
    killFloating();
    var kp = setInterval(killFloating, 500); setTimeout(function () { clearInterval(kp); }, 24000);

    var ioHero = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { sticky.classList.toggle('is-visible', !entry.isIntersecting); });
    }, { threshold: 0.1 });
    ioHero.observe(heroCta);

    if (finalSec) {
      var ioFinal = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { section.classList.toggle('is-final-cta-visible', entry.isIntersecting); });
      }, { threshold: 0.15, rootMargin: '0px 0px -40% 0px' });
      ioFinal.observe(finalSec);
    }

    var btn = $('.hm-smk-sticky-cta__btn', sticky);
    if (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var rsiBtn = document.querySelector('._rsi-buy-now-button:not(._rsi-buy-now-button-floating), #_rsi-buy-now-button-overwrite');
        if (rsiBtn) { rsiBtn.click(); return; }
        var mainCta = document.querySelector('[data-hm-smk-main-cta]');
        if (mainCta) { mainCta.click(); return; }
        finalSec && finalSec.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  })();

  console.info('[HERMES smilekit-v1] Section initialized.');
})();
